<section class="app-table-container" animated>
    <mat-table [dataSource]="dataSource"
               [class.mobile-layout]="mobileMode$ | async"
               class="violation-history-table"
               appTable
               multiTemplateDataRows>
        <ng-container matColumnDef="mobile">
            <mat-header-cell *matHeaderCellDef>{{ columnMap[0].title }}</mat-header-cell>
            <mat-cell *matCellDef="let row">
                {{ row.eventName }}
                <ng-container *ngIf="row.creator">{{ ' by ' + row.creator }}</ng-container>
                <ng-container *ngIf="row.recipient">{{ ' to ' + row.recipient }}</ng-container>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="eventSummary">
            <mat-header-cell *matHeaderCellDef>{{ columnMap[1].title }}</mat-header-cell>
            <mat-cell *matCellDef="let row">
                {{ row.eventName }}
                <ng-container *ngIf="row.creator">{{ ' by ' + row.creator }}</ng-container>
                <ng-container *ngIf="row.recipient">{{ ' to ' + row.recipient }}</ng-container>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="createdAt">
            <mat-header-cell *matHeaderCellDef>{{ columnMap[2].title }}</mat-header-cell>
            <mat-cell *matCellDef="let row">
                {{ row.createdAt | legfiDate:'MM/DD/YYYY h:mm a' }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="detail">
            <mat-header-cell *matHeaderCellDef justifyRightCell>{{ columnMap[3].title }}</mat-header-cell>
            <mat-cell *matCellDef="let row" justifyRightCell>
                <!-- status change (shows status user changed it to) -->
                <app-status-chip *ngIf="row.eventType === 'status' && statuses?.length > 0"
                                 [loadingInitialData]="isLoadingHistory"
                                 [statusId]="violation?.violationStatusId"
                                 [label]="'Violation status'"
                                 [statuses]="statuses">
                </app-status-chip>

                <!-- applied a charge -->
                <span *ngIf="row.eventType === 'charge'">
                    {{ 'Applied fine of ' + (row.content | legfiCurrency:'USD':'symbol':'.2') }}
                </span>

                <!-- sent mail -->
                <a *ngIf="row.eventType === 'mail'"
                   mat-flat-button linkButton disableRipple
                   target="_blank"
                   [href]="row.content">
                    {{ 'View Mail' }}
                </a>

                <!-- show ability to view associated history detail (if available) -->
                <button *ngIf="isEventTypeWithLinkButton(row)"
                        mat-flat-button linkButton disableRipple preventClick
                        (click)="showViolationHistoryDetail(row)">
                    {{ 'View Details' }}
                </button>
            </mat-cell>
        </ng-container>

        <div *matNoDataRow>
        </div>

        <ng-container matColumnDef="workingProgressBar">
            <mat-cell *matCellDef="let row">
                <mat-progress-bar mode="query" color="primary" [class.active]="!isLoadingHistory && refreshingViolationHistory"></mat-progress-bar>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columnKeys$ | async; sticky: true"
                        [headerRow]="true"
                        appTableRow>
        </mat-header-row>
        <mat-row *matRowDef="let row; columns: ['workingProgressBar']; let isFirst = first"
                 [workingRow]="true"
                 [firstRow]="isFirst"
                 appTableRow>
        </mat-row>
        <mat-row *matRowDef="let row; columns: columnKeys$ | async"
                 animated
                 delayed="table"
                 [hasAnimation]="rowsAnimated"
                 appTableRow>
        </mat-row>
    </mat-table>
</section>
